import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import environment from "web/script/modules/environment";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { StandardFilterProps } from "web/types/feed-filters";
import { CategoryFilterOption, InputFilterOption } from "web/types/universal-filters";
import { FilterUXVariant } from "web/react/components/feeds-filters/filter-variants";
import styles from "./checkbox-filter-item.css";

interface CheckboxFilterItemProps extends StandardFilterProps {
    item: InputFilterOption | CategoryFilterOption;
    isSmallItem?: boolean;
    hasChildren?: boolean;
    ariaControls?: string;
    siblingOpen?: boolean;
}

const CheckboxFilterItem = function CheckboxFilterItem({
    ariaControls,
    isSmallItem,
    item,
    onClick,
    pendingFilterInfo,
    hasChildren,
    siblingOpen,
}): JSX.Element {
    const isCategoryHeading = item.type == "category";
    const isRadioButton = item.type == "radio";

    const filterVariant = environment.getFeature("mg_test_filter_ux");

    function handleClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        event.preventDefault();
        if (!hasChildren) {
            // when `mg_test_filter_ux` is done we can remove this event
            analytics.event("filter_ux", "click", "leaf");
        }
        onClick(item);
    }

    let checked = pendingFilterInfo.getChecked(item);

    let showArrow = hasChildren;
    let hideLeftIcon = filterVariant == FilterUXVariant.HIDE_CATEGORY_SIBLINGS && hasChildren;
    let hideSibling =
        filterVariant == FilterUXVariant.HIDE_CATEGORY_SIBLINGS ||
        filterVariant == FilterUXVariant.OTHER_BUTTON_AVAILABLE;

    return (
        <a
            href={item.url}
            className={classnames(styles.filterItem, {
                [styles.selectedLabel]: checked,
                [styles.smallFilterItem]: isSmallItem,
                [styles.siblingOpen]: hideSibling && siblingOpen && !checked,
                [styles.noIconLeft]: hideLeftIcon,
            })}
            onClick={handleClick}
            role="button"
            aria-expanded={hasChildren ? checked : undefined}
            aria-controls={hasChildren ? ariaControls : undefined}
        >
            {!hideLeftIcon && (
                <div className={styles.icon}>
                    {isCategoryHeading || isRadioButton ? (
                        checked ? (
                            <SVGIcon name={"round-radiobutton-checked"} />
                        ) : (
                            <SVGIcon name={"round-radiobutton"} />
                        )
                    ) : checked ? (
                        <SVGIcon name={"round-checkbox-checked"} />
                    ) : (
                        <SVGIcon name={"round-checkbox"} />
                    )}
                </div>
            )}
            <span className={styles.labelItem}>{item.label}</span>
            {showArrow && (isCategoryHeading || isRadioButton) && (
                <SVGIcon
                    className={classnames(styles.arrow, { [styles.rotate]: checked })}
                    name="round-chevron"
                />
            )}
        </a>
    );
} as React.FC<CheckboxFilterItemProps>;

export default CheckboxFilterItem;

CheckboxFilterItem.defaultProps = {
    isSmallItem: false,
};
